// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__294a9","overflowing":"ReadFullNote_overflowing__1-6y0"};